<template lang="html">

  <footer class="footer row-between">

    <div class="logos-pie row-start">
      <a href="https://fundacion.usal.es/es/" target="_blank"><img src="/static/img/logo-uni.svg"  alt="Logo USAL"></a>
      <a href="https://www.usal.es/" target="_blank"><img src="/static/img/fgusal-bl.png" width="86px"  alt="Logo Fundacion"></a>
    </div>

    
    <nav class="column-center">
      <a target="_blank" href="https://fundacion.usal.es/es/aviso-legal-y-codigo-etico">Aviso legal</a>
      <a target="_blank" href="https://fundacion.usal.es/es/politica-de-privacidad">Política de privacidad</a>
      <a target="_blank" href="https://fundacion.usal.es/es/politica-de-cookies">Política de Cookies</a>
      <p>Universidad de Salamanca © 2021</p>
    </nav>

  </footer>

</template>

<script lang="js">
  export default {
    name: 'app-footer',
  }
</script>

<style scoped>
  .footer {}
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue